import { Observable, of } from 'rxjs';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { User } from '@nimmsta/ng-commons-lib/models';

export class CheckSecondaryUserAction extends CustomAction<User> {
  private forSecondary: boolean;

  constructor(text: string, forSecondary: boolean) {
    super(text);
    this.forSecondary = forSecondary;
  }

  override isEnabled(item: User): Observable<boolean> {
    return of(item.isSecondaryOrgMember === this.forSecondary);
  }
}
